<template>
  <div class="wrapper-background">
		<div class="login">
			<div class="content">
				<div class="login__card">
					<div class="card-logo">
						<img class="card-logo__img" :src="$store.state.businessImage||logoDefault" alt="">
					</div>
					<div class="card-name" v-if="$store.state.subdomain">
						<span class="name card--basic">{{$store.state.subdomain}}</span>
						<span class="name card--complement">.fastfox.io</span>
					</div>
				</div>
        <div class="business__access"  v-if="!$store.state.subdomain">
          <b-field class="type-select">
            <b-input name="business" class="input-custom input-custom--min wrap-input" type="text" placeholder="Empresa" @blur="getBusiness" v-model="business"></b-input>
            <b-input name="business" type="text" placeholder="Empresa" value=".fastfox.io" disabled></b-input>
          </b-field>
        </div>
				<div class="login__access">
          <form v-on:submit.prevent="validate" data-vv-scope="login" ref="form">
            <b-field class="type-select" :type="errors.has('login.email') ? 'is-danger': ''" :message="errors.has('login.email') ? errors.first('login.email') : ''">
              <b-input name="email" class="input-custom input-custom--min wrap-input"  type="email" placeholder="Correo electrónico" value="" v-model="emailData" v-validate="'required|email'" autocomplete="off"></b-input>
            </b-field>
            <b-field class="type-select" :type="errors.has('login.contraseña') ? 'is-danger': ''" :message="errors.has('login.contraseña') ? errors.first('login.contraseña') : ''">
              <b-input name="contraseña" class="input-custom input-custom--min wrap-input" type="password" placeholder="Contraseña" value="" v-model="passData" v-validate="'required'" password-reveal></b-input>
            </b-field>
            <button type="submit" class="button ripple btn-log" v-if="loadingSet"><img src="../../assets/loader.svg" alt="loading" class="load-svg"></button>
            <button type="submit" class="button ripple btn-log" v-else>INGRESAR</button>
            <div class="logError" v-if="messageErrorLog">
              <p>{{message}}</p>
            </div>
          </form>
				</div>

			</div>
    </div>
  </div>
</template>

<script>
import { service } from "../../helper/Rest.js";
import { mapMutations } from "vuex";
import VueLocalStorage from "vue-localstorage";
export default {
  name: "login",
  props: ['subdomain'],
  data() {
    return {
      colorx: "#F3A30A",
      colorBasic: "RGB(138, 94, 44)",
      colorComplement: "RGB(237, 172, 0)",
      email: "",
      password: "",
      validos: {
        email: false,
        password: false
      },
      messageErrorLog: false,
      loadingSet: false,
      emailData: "",
      passData: "",
      message: "El correo o la contraseña son incorrectos.",
      business: "",
      logoDefault: require("../../assets/logo-main.png")
    };
  },
  methods: {
    ...mapMutations(["addbuildings"]),
    validate: function() {
      this.$validator.validateAll("login").then(result => {
        if (result) {
          this.loadingSet = true;
          this.actionLog();
        } else {
          this.loadingSet = false;
        }
      });
    },
    actionLog: function() {
      let setLogin = {
        username: this.emailData,
        password: this.passData,
        apiKey: this.$store.state.apiKey
      };
      service
        .login(setLogin)
        .then(
          res => {
            var data = res.data;
            this.$localStorage.set("userId", data.user.id);
            this.$localStorage.set("companyId", data.business.id);
            if(data.business.roleIn === 'master'){
              this.$store.commit("setRoleMaster")
            }
            this.$store.commit("addCompanyData", data.business);
            this.$store.commit("setCompanyId", data.business.id);
            this.$store.commit("currentUser", data.user);
            if(data.business.roleIn === "master"){
              this.$store.commit("setRoleMaster");
              this.$store.commit("setRoleMasterEdit");
            }
            this.$store.commit("changeColors", data.business);
            var colors = {
              hmenuColor: this.$store.state.configuration.headerColor,
              hbodyColor: this.$store.state.configuration.menuColor
            };
            this.$localStorage.set("colors", JSON.stringify(colors));
            service.updateHeaders({token: data.accessToken, apiKey: this.$store.state.apiKey});
            service.getCompany(this.$store.getters.companyID).then(response => {
              var image = {
                file: response.data.image,
                preview: ""
              };
              this.$store.commit("addCompanyData", response.data);
              this.$store.commit("changeLogo", image);
              this.$store.dispatch("GETBUILDINGS");
            });
            this.routingLogin();
          },
          err => {
            this.messageErrorLog = true;
            if (err.response.status == 403) {
              this.message = err.response.data.message;
            }
            this.loadingSet = false;
            (this.emailData = ""), (this.passData = "");
          }
        )
        .catch(error => {
          this.reloading();
          this.messageErrorLog = true;
          this.loadingSet = false;
          (this.emailData = ""), (this.passData = "");
        });
    },
    routingLogin: function() {
      if(this.$store.state.currentUser.isAdmin){
          this.$router.push({name: 'businesses'});
        }else {

          this.$router.push("/main/dashboard");
        }
    },
    reloading: function() {
      this.$router.push("/");
    },
    getBusiness: function(){
      console.log(this.business);
      
      this.$store.dispatch("GETAPIKEY", this.business).then(res => {
        if(res == 200){
          this.$toast.open({
            message: "Empresa obtenida con éxito",
            position: "is-bottom-right",
            type: "ffcolor-is-success"
          });
        }else{
          this.$toast.open({
            message: "Empresa inválida",
            position: "is-bottom-right",
            type: "ffcolor-is-delete"
          });
        }
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" >
.wrapper-background {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #ffffff 0%,
    #ffffff 35%,
    #fafafa 35%,
    #fafafa 35%,
    #fafafa 35%,
    #fafafa 100%
  );
}
.login {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // transform: scale(1.1);
  transform: translateY(-10%);
  .content {
    width: 250px;
    transform: scale(1.2);
  }
}
.login__access {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  text-align: left;
  .field {
    margin-bottom: 1rem;
  }
  .logError {
    margin-top: 10px;
    text-align: center;
    p {
      font-size: 12px;
      color: #ff3860;
    }
  }
}
.card-logo,
.card-name {
  text-align: center;
}
.card-logo {
  margin-bottom: 5px;
  &__img{
    max-height: 150px;
  }
}
.card-name {
  margin-top: -15px;
  display: inline-block;
  transform: scaleY(0.9);
}
.name {
  font-family: "Roboto";
  font-size: 25px;
  font-weight: bold;
  height: 10px;
}
.card--basic {
  color: #053d5f;
  // color: RGB(138, 94, 44);
}
.card--complement {
  color: RGB(237, 172, 0);
}

.btn-log {
  // -webkit-appearance: value !important;
  // -moz-appearance: value !important;
  // appearance: none !important;
  width: 100% !important;
  color: white !important;
  font-size: 15px;
  height: 3em;

  // transform: scale(.5);
  // background-color: #f3a30a;
  // border: 1px solid #f3a30a;
  background-color: #053d5f !important;
  border: 1px solid #053d5f;
  transition: all 0.2s ease;
  &:active,
  &:focus,
  &:hover {
    border: 1px solid #053d5f;
    // box-shadow: 0 9px 28px -9px rgb(243, 163, 10) !important;
    box-shadow: 0 9px 28px -9px rgb(5, 61, 95) !important;
  }
  .load-svg {
    width: 20px;
  }
}
.type-select {
  position: relative;
  .input-custom--min {
    .input {
      &:hover,
      &:active,
      &:focus {
        border-color: #b5b5b5;
        box-shadow: none;
      }
    }
    .is-danger {
      &:hover,
      &:active,
      &:focus {
        border-color: #ff3860;
        box-shadow: none;
      }
    }
    .has-text-danger {
      color: #ff3860 !important;
    }
  }
}
// .input-placeholder {
// margin-left: 0 !important;
// margin-right: 0 !important;
// width: 100% !important;

// .input-custom {
// }
</style>



// WEBPACK FOOTER //
// src/components/Main/login.vue